export const frequentServiceRouteShortNames = [
  "1",
  "110",
  "120",
  "130",
  "2",
  "21",
  "22",
  "220",
  "3",
  "4",
  "7",
  "AX",
  "HVC",
  "HVH",
  "HVM",
  "HVN",
  "HVT",
  "HVU",
  "HVW",
  "JVC",
  "JVH",
  "JVM",
  "JVN",
  "JVR",
  "JVT",
  "JVU",
  "JVW",
  "KPC",
  "KPH",
  "KPM",
  "KPN",
  "KPT",
  "KPU",
  "KPW",
  "MEC",
  "MEH",
  "MEM",
  "MEN",
  "MET",
  "MEU",
  "MEW",
  "MIF",
];

export const multiPlatformStopIds = [
  "WELL",
  "KHAN",
  "MANA",
  "NGAI",
  "PAEK",
  "PARA",
  "PETO",
  "PLIM",
  "PORI",
  "REDW",
  "TAIT",
  "TAKA",
  "TAWA",
  "TREN",
  "WALL",
  "WATE",
  "WOBU",
];

export const cableCarStopIds = ["KELB", "SALA", "TALA", "CLIF", "LAMB"];

export const ferryStopIds = ["9997", "9998", "9999"];

export const isFrequentRoute = (routeLabel) =>
  frequentServiceRouteShortNames.includes(routeLabel);
